import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "hiddenItems", "loadMoreButton"]

  showAll() {
    if (this.hasHiddenItemsTarget) {
      // Move hidden items to visible container
      const hiddenContent = this.hiddenItemsTarget.innerHTML
      this.containerTarget.insertAdjacentHTML("beforeend", hiddenContent)
      this.hiddenItemsTarget.remove()
    }
    
    // Hide the load more button
    if (this.hasLoadMoreButtonTarget) {
      this.loadMoreButtonTarget.classList.add("hidden")
    }
  }
}

